import styled from 'styled-components';
import { space } from 'shared';
import _FooterWrapper from './FooterWrapper';

export const Main = styled.main`
  background-color: ${({ hideChrome, theme }) => (hideChrome ? theme.loginSurface : theme.mainBackgroundColor)};
  padding: ${({ hideChrome, theme }) => (hideChrome ? '0' : space(30, 0, 60)({ theme }))};
  position: relative;
  z-index: 1;
  flex-grow: 1;
  /* Login-Award-Redesign: der 100vw-full-bleed der LoginStage ragt bei klassischen
     (nicht-Overlay-)Scrollbars um die Scrollbar-Breite über die Layout-Breite hinaus,
     sobald vertikal gescrollt wird -> würde einen horizontalen Scrollbalken erzeugen.
     overflow-x: clip kappt genau diesen Überstand (nur rechtes Panel-Padding), ohne
     vertikales Scrollen zu berühren. Nur auf /login (hideChrome). */
  ${({ hideChrome }) => (hideChrome ? 'overflow-x: clip;' : '')}
`;

export const FooterWrapper = styled(_FooterWrapper)`
  height: 155px;
`;
